<template>

  <Modal :modalConfig.sync="modalConfig" @onClose="closeModal" @onOk="onModalOk" :visible.sync="modalConfig.visible">
    <el-cascader-panel v-model="panelValue" :options="options" :props="cascaderPanelProps" style="height: 600px;width: 700px"></el-cascader-panel>
    <div class="dialog-footer">
      <slot name="footer">
        <el-button icon="el-icon-check" type="primary" @click="onModalOk">确定</el-button>
        <el-button icon="el-icon-close" type="danger" @click="closeModal">取消</el-button>
      </slot>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/found/components/modal';
import { CascaderPanel } from 'element-ui';
import request from '@/found/utils/request';

export default {
  name: 'adressModal',
  components: {
    Modal,
    'el-cascader-panel': CascaderPanel, //
  },
  data() {
    return {
      cascaderPanelProps: {
        multiple: true,
        value: 'regionCode',
        label: 'regionName',
        children: 'childList',
        checkStrictly: true,
      },
      modalConfig: {
        type: 'Modal',
        title: '选择',
        visible: false,
        width: '700',
        height: '600',
      }, // 弹框信息
      panelValue: [],
      flatDataMap: new Map(),
      options: [],
      originData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 扁平化数据并建立映射
    flattenOptions(options, parentPath = []) {
      options.forEach((item) => {
        // 构建完整路径和层级信息
        const fullPath = [...parentPath, item.regionCode];
        const nodeInfo = {
          ...item,
          fullPath,
          parentPath,
        };

        // 存储到 Map 中
        this.flatDataMap.set(item.regionCode, nodeInfo);

        // 递归处理子节点
        if (item.childList && item.childList.length > 0) {
          this.flattenOptions(item.childList, fullPath);
        }
      });
    },

    onModalOk() {
      const arr = [];
      this.panelValue.forEach((val, index) => {
        let obj = {
          id: index,
        };
        const country = this.flatDataMap.get(val[0]);
        if (country) {
          obj = {
            ...obj,
            pcountryName: country.regionName,
            countryCode: val[0],
          };
        }
        const province = this.flatDataMap.get(val[1]);
        if (province) {
          obj = {
            ...obj,
            provinceName: province.regionName,
            provinceCode: val[1],
          };
        }
        const city = this.flatDataMap.get(val[2]);
        if (city) {
          obj = {
            ...obj,
            cityName: city.regionName,
            cityCode: val[2],
          };
        }
        const district = this.flatDataMap.get(val[3]);
        if (district) {
          obj = {
            ...obj,
            districtName: district.regionName,
            districtCode: val[3],
          };
        }
        arr.push(obj);
      });
      this.closeModal();
      this.$emit('onOk', arr);
    },
    getData() {
      request.post('/mdm/mdmRegionController/treeList').then((res) => {
        if (res.success) {
          this.options = res.result.data || [];

          this.flattenOptions(res.result.data);
        }
      });
    },
    // 关闭弹窗
    closeModal() {
      this.modalConfig.visible = false;
    },
  },
};
</script>
<style lang="less">

:deep(.el-cascader-menu) {
  height: 100% !important;
}
:deep(.el-cascader-menu__wrap) {
  height: 100% !important;
}
</style>
